import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';
import { emptyEthAddress } from '../utils/util';

export interface AccountState {
    balance: string;
    address: string;
}

const initialState: AccountState = {
    balance: '0.00',
    address: emptyEthAddress,

};

export const accountSlice = createSlice({
    name: 'account',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setBalance: (state: AccountState, action: PayloadAction<string>) => {
            state.balance = action.payload;
        },
        setAddress: (state: AccountState, action: PayloadAction<string>) => {
            state.address = action.payload;
        }
    },

});

export const { setBalance, setAddress } = accountSlice.actions;

export const selectBalance = (state: RootState) => state.account.balance;
export const selectAddress = (state: RootState) => state.account.address;

export default accountSlice.reducer;
